import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createSelectOptionSchema } from '../../schema';
import {
  CoverageCheckupState,
  goToNextStep,
  updateCoverageCheckupState,
} from '../../../store/step';
import Select from '@ramsey-design-system/select';
import { FormikFormField } from '@frontman/rt-protections-ui';
import { retirementSavingsRange } from '../../../utils/shared';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function RetirementSavingsStep(): ReactElement {
  const dispatch = useDispatch();
  const { retirementSavings: retirementSavings } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('retirement_savings');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <CardPadding>
      <CardHeader
        header=" How much do you have in retirement savings (401k, 403b, IRA, etc.)?"
        subHeader="This determines your need for two types of coverage."
      />
      <Formik
        initialValues={{ retirementSavings }}
        onSubmit={onSubmit}
        validationSchema={createSelectOptionSchema('retirementSavings')}
      >
        <Form ref={formRef}>
          <FormikFormField<CoverageCheckupState>
            id="retirementSavings"
            name="retirementSavings"
            className="u-spacingBlockMd"
            inputComponent={Select}
            rdsAttributes={{ length: 'lg' }}
          >
            <option value="">Select an Option</option>
            {retirementSavingsRange.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </FormikFormField>
          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { RetirementSavingsStep };
